module.exports = __webpack_public_path__ + "img/deo.469f7179.png";